import { useNavigation, useUrlContext } from '@msdk/common'
import { sanitizeuUrl } from '@msdk/ui/src/components/Markdown/url-sanitizer'
import { Link } from '@mui/material'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { getAdditionalContextFromLink, navigateToLink } from './LinkNotificationUtils'

export interface Props {
  children: ReactNode | ReactNode[]
  href: string | undefined
  tenant: string
  onClose: () => void
}

export function NotificationLink({ children, href, tenant, onClose }: Props) {
  const navigate = useNavigation()
  const reactNavigate = useNavigate()
  const urlContext = useUrlContext()

  const isRelativeUrl = (href as string)?.includes('##tenantBaseUrl##') //##tenantBaseUrl## is used only to understand if it's a relative url or not
  let url = sanitizeuUrl((href as string)?.replaceAll('##tenantBaseUrl##', ''))
  const currentPage = (href as string)?.includes('##currentPage##') //##currentPage## is used only to understand if it's requested to remain on the same page
  if (currentPage) {
    href = (href as string)?.replaceAll('##currentPage##', '')
    const incomingParams = new URLSearchParams(href)
    const actualParams = new URLSearchParams(window.location.search)
    const newParams = new URLSearchParams([
      ...Array.from(actualParams.entries()),
      ...Array.from(incomingParams.entries()),
    ])
    url = window.location.pathname + '?' + newParams.toString()
  }
  const openLink = (link: string) => {
    const additionalCtx = isRelativeUrl ? getAdditionalContextFromLink(link) : undefined
    onClose()
    navigateToLink(
      link,
      isRelativeUrl,
      urlContext.context.sitemap,
      tenant,
      navigate,
      reactNavigate,
      additionalCtx,
      currentPage,
    )
  }

  return (
    <Link underline="none" rel="noreferrer" onClick={() => openLink(url)}>
      {children}
    </Link>
  )
}
